<template>
<Popover
    :lazy="false"
    :arrow="false"
    placement="bottom-end"
    class="tools-popover">
    <span
        class="tools-popover-icon"
        @mouseover="onHover(true)"
        @mouseout="onHover(false)"
        :style="setIconStyle(isHover)"
    >
        <svg
            slot="tools"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 3H5.8V5.8H3V3ZM3 8.6H5.8V11.4H3V8.6ZM5.8 14.2H3V17H5.8V14.2ZM8.6 3H11.4V5.8H8.6V3ZM11.4 8.6H8.6V11.4H11.4V8.6ZM8.6 14.2H11.4V17H8.6V14.2ZM17 3H14.2V5.8H17V3ZM14.2 8.6H17V11.4H14.2V8.6ZM17 14.2H14.2V17H17V14.2Z"
            />
        </svg>
    </span>

    <template v-slot:content>
        <span @mouseenter="onHover(true)" @mouseleave="onHover(false)">
            <Tools />
        </span>
    </template>

</Popover>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tools from '../tools';
import { Popover } from '@gaoding/gdui';
export default {
  name: 'tools-popover',
  components: {
    Tools,
    Popover
  },
  props: {
    // 设置浮窗被hover时，icon的hover样式
    setIconStyle: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      isHover: false
    };
  },

  methods: {
    onHover(isHover) {
      this.isHover = isHover;
    }

  }
};
</script>
<style scoped>
.tools-popover {
  margin-right: 32px;
  width: 20px;
  height: 20px;
}
.tools-popover-icon {
  cursor: pointer;
  position: relative;
  fill: #D9DCDF;
}
.tools-popover-icon:hover::before {
  content: '';
  position: absolute;
  width: 60px;
  height: 20px;
  top: 15px;
  left: -20px;
}

</style>
<style>
.tools-popover .g-popover {
  margin-right: -36px;
  margin-top: 15px !important;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
}

</style>
